import Vue from 'vue';
import Router from 'vue-router';
import Schedule from '@/components/Schedule/Schedule';
import AddSchedule from '@/components/Schedule/AddSchedule';
import Pending from '@/components/Pending/Pending';
import History from '@/components/History/History';
import Blocked from '@/components/Blocked/Blocked';
import AddBlocked from '@/components/Blocked/AddBlocked';
import EditBlocked from '@/components/Blocked/EditBlocked';
import Cities from '@/components/Cities/Cities';
import AddCities from '@/components/Cities/AddCities';
import EditCities from '@/components/Cities/EditCities';
import Walls from '@/components/Walls/Walls';
import AddWalls from '@/components/Walls/AddWalls';
import EditWalls from '@/components/Walls/EditWalls';
import Partners from '@/components/Partners/Partners';
import AddPartners from '@/components/Partners/AddPartners';
import EditPartners from '@/components/Partners/EditPartners';
import Featured from '@/components/Featured/Featured';
import AddFeatured from '@/components/Featured/AddFeatured';
import EditFeatured from '@/components/Featured/EditFeatured';
import ScreenSavers from '@/components/ScreenSavers/ScreenSavers';
import AddScreenSavers from '@/components/ScreenSavers/AddScreenSavers';
import EditScreenSavers from '@/components/ScreenSavers/EditScreenSavers';
import Notifications from '@/components/Notifications/Notifications';
import Signin from '@/components/Signin/Signin';
import * as AuthService from '@/services/auth.service';

Vue.use(Router);

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Schedule,
    },
    {
      path: '/blocked',
      name: 'Blocked',
      component: Blocked,
    },
    {
      path: '/blocked/add',
      name: 'AddBlocked',
      component: AddBlocked,
    },
    {
      path: '/blocked/edit/:id',
      name: 'EditBlocked',
      component: EditBlocked,
    },
    {
      path: '/pending',
      name: 'Pending',
      component: Pending,
    },
    {
      path: '/history',
      name: 'History',
      component: History,
    },
    {
      path: '/schedule',
      name: 'Schedule',
      component: Schedule,
    },
    {
      path: '/schedule/add',
      name: 'AddSchedule',
      component: AddSchedule,
    },
    {
      path: '/cities',
      name: 'Cities',
      component: Cities,
    },
    {
      path: '/cities/add',
      name: 'AddCities',
      component: AddCities,
    },
    {
      path: '/cities/edit/:id',
      name: 'EditCities',
      component: EditCities,
    },
    {
      path: '/walls',
      name: 'Walls',
      component: Walls,
    },
    {
      path: '/walls/add',
      name: 'AddWalls',
      component: AddWalls,
    },
    {
      path: '/walls/edit/:id',
      name: 'EditWalls',
      component: EditWalls,
    },
    {
      path: '/partners',
      name: 'Partners',
      component: Partners,
    },
    {
      path: '/partners/add',
      name: 'AddPartners',
      component: AddPartners,
    },
    {
      path: '/partners/edit/:id?',
      name: 'EditPartners',
      component: EditPartners,
    },
    {
      path: '/featured',
      name: 'Featured',
      component: Featured,
    },
    {
      path: '/featured/add',
      name: 'AddFeatured',
      component: AddFeatured,
    },
    {
      path: '/featured/edit/:id?',
      name: 'EditFeatured',
      component: EditFeatured,
    },
    {
      path: '/screensavers',
      name: 'ScreenSavers',
      component: ScreenSavers,
    },
    {
      path: '/screensavers/add',
      name: 'AddScreenSavers',
      component: AddScreenSavers,
    },
    {
      path: '/screensavers/edit/:id?',
      name: 'EditScreenSavers',
      component: EditScreenSavers,
    },
    {
      path: '/notifications',
      name: 'Notifications',
      component: Notifications,
    },
    {
      path: '/signin',
      name: 'Signin',
      component: Signin,
      meta: { public_route: true },
    },
  ],
});

router.beforeEach((to, from, next) => {
  if(to.meta.public_route) {
    next();
  }else{

    var jwt = AuthService.isLoggedin();
    if(jwt){
      jwt = JSON.parse(atob(jwt.split('.')[1]));
    }

    if (jwt && jwt.exp > Date.now() / 1000) {
      next();
    }
    else {
      AuthService.logout();
      next('/signin');
      window.vm.$children[0].is_logged_in = false;
    }
  }
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js